import { CircularProgress, Box, Typography } from "@mui/material";
import { BlockMap } from '@product-fusion/surya-fw';
import LockOutlineIcon from '@mui/icons-material/LockOutline';
import Legend from "../../../shared/Dashboard/legend";
import { COLORS } from "../../../shared/constent/legendConstants";
import { useParams } from "react-router-dom";
const LayoutComponent = (props) => {
  const { id } = useParams()
  const { loader, data, projectList, setSelectedRow, selectedRow, currentSelection, qcProgressData, layoutType = "CP", showType = "pier", showLegend = true, lockUnlockData = {}, lockTypeSelection, currentPunchlistStatus, activityType, setDownloadD3Loading } = props;
  const { bulkAllData, mapSize, pierlegends, typeData, tableCoordinates } = data || {};
  const currentBlockDetails = data?.blocks?.find(o => o.id === parseInt(id))
  const currentProject = projectList.find(o => o.id === parseInt(localStorage.getItem("project_id")))

  const hasValidPiers = bulkAllData?.piers && Object.keys(bulkAllData.piers).length > 0;
  const hasValidTT = bulkAllData?.tt && Object.keys(bulkAllData.tt).length > 0;

  const safeBulkAllData = (hasValidPiers && hasValidTT) ? bulkAllData : {};;
  return (
    <Box>
      {loader ? (
        <Box sx={{
          height: "calc(100vh - 200px)",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <BlockMap
            data={safeBulkAllData}
            d3Size={mapSize}
            pierLegends={pierlegends}
            progressColorData={layoutType === "QC" || layoutType === "Punchlist" ? qcProgressData : typeData}
            lockUnlockData={lockUnlockData}
            currentProjectDetails={projectList.find(o => o.id === parseInt(localStorage.getItem("project_id")))}
            currentBlockDetails={currentBlockDetails}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            type={{
              deviceType: "web",
              layoutType: layoutType,
              activityType: activityType,
              projectType: currentProject?.type === 1 ? "zimmerman" : "nexttracker",
            }}
            userSelection={{
              showType: showType,
              selection: currentSelection,
              lockTypeSelection: lockTypeSelection,
              punchlistStatusSelection: currentPunchlistStatus
            }}
            boolean={{
              controls: true,
              enableGPSLocation: false,
              laydown: false,
              downloadD3: setDownloadD3Loading
            }}
            tableCoordinatesData={tableCoordinates} />

          {showLegend && <Box
            sx={{ position: "absolute", bottom: 45, left: layoutType === "QC" ? "25%" : "20%", display: "flex", flexDirection: "row", flexWrap: "wrap" }}
          >
            <Legend layoutType={layoutType} />
          </Box>
          }
          {layoutType === "QC" && showLegend && <Box sx={{
            position: "absolute",
            bottom: 10,
            left: "29%",
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
          }}>
            <LockOutlineIcon fontSize="small" sx={{ color: COLORS.LOCKED }} />
            <Typography fontSize={16} fontWeight={600} color="#878787">QC Checklist Locked</Typography>
          </Box>}
        </Box>
      )
      }
    </Box >
  );
};

export default LayoutComponent;
